module.exports = new __parcel__URL__("Doge.9d700487.png").toString();